export function saveUserLanguage(lang) {
  if (!lang) return;
    // console.log("Saving user language: ", lang);
  localStorage.setItem("userLanguage", lang);
}

export function loadUserLanguage() {
  return localStorage.getItem("userLanguage");
}
